import { InitialQueryData } from '@data/queries/types'
import { ObjectSchema, object } from 'yup'

function normalizeEmptyItem(_originalValue: unknown, currentValue: unknown): object {
    // The backend serializer will render `[]` for empty items, so let's convert it to an object
    if (Array.isArray(currentValue) || !currentValue) {
        return {}
    }

    return currentValue
}

// These items don't need any further validation at this point because they will be passed to a mapper before being consumed by a component or hook
export const schema: ObjectSchema<InitialQueryData, InitialQueryData> = object<InitialQueryData>().shape({
    experiments: object().transform(normalizeEmptyItem),
    member: object(),
    group: object(),
    interruptions: object(),
    alerts: object(),
    announcementBanner: object(),
    calendarTeaser: object(),
    groupsTeaser: object(),
    profileVisitTeasers: object(),
    memberRecommendationTeasers: object(),
})
